module.exports = __webpack_public_path__ + "img/school-blue.8127fb2d.svg";